<div class="search-options" (click)="showMoreOptions()" translate>customer.searchOptions<i style="margin-left: 6px;"
    class="fa fa-chevron-down"></i></div>
<div class="search-fields">

  <div class="select">
    <form>
      <div id="datepicker" class="form-group hide-date">
        <div class="input-group">
          <input name="datepicker" style="display: none;" class="form-control" ngbDatepicker
            [footerTemplate]="footerTemplate" #datepicker="ngbDatepicker" [autoClose]="'outside'"
            (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden"
            [startDate]="fromDate!">
          <ng-template #t let-date="date" let-focused="focused">
            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
              {{ date.day }}
            </span>
          </ng-template>
          <ng-template #footerTemplate>
            <hr class="my-0">
            <button class="btn btn-primary btn-sm m-2 float-left" (click)="lastWeek(); datepicker.close()"
              translate>customer.lastWeek</button>
            <button class="btn btn-secondary btn-sm m-2 float-right" (click)="lastMonth(); datepicker.close()"
              translate>customer.lastMonth</button>
          </ng-template>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4 col-lg-3" style="width: 380px; margin-right: 0;">
          <p style="font-size: .9rem;" translate>customer.from</p>
          <div class="input-group">
            <input #dpFromDate id="fromDate" class="form-control date-input" placeholder="yyyy-mm-dd" name="dpFromDate"
              [ngModel]="formatter.format(fromDate)" (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" style="border: none;" (click)="datepicker.toggle()"
                type="button"></button>
            </div>
          </div>
        </div>
        <div class="form-group col-md-4 col-lg-3" style="width: 380px; margin-right: 0;">
          <p style="font-size: .9rem;" translate>customer.to</p>
          <div class="input-group">
            <input #dpToDate id="toDate" class="form-control date-input" placeholder="yyyy-mm-dd" name="dpToDate"
              [value]="formatter.format(toDate)" (input)="toDate = validateInput(toDate, dpToDate.value)">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" style="border: none;" (click)="datepicker.toggle()"
                type="button"></button>
            </div>
          </div>
        </div>
        <div class="select bg-light col-md-4 col-lg-3" style="width: 380px; margin-right: 0; margin-top: 18px;">
          <app-select-with-search class="select" *ngIf="currentUser.role.name === 'root' && router.url.includes('/root/vehicles')" [options]="customers"
            [bgColor]="'var(--clr-primary-light)'" [placeholder]="'notifications.selectCustomer'" [defaultSelect]="selectedCustomer" (selectionChange)="onCustomerSelect($event)">
          </app-select-with-search>
        </div>
      </div>
    </form>
  </div>

  <div class="row">
    <div *ngIf="areCustomerVehicles && currentUser.role.name === 'customer'"
      class="select bg-light my-2 col-md-4 col-lg-3" style="width: 380px; margin-right: 0;">
      <div class="p-0 mb-2 search-text d-flex">
        <input type="text" class="form-control" (keydown.enter)="searchVehicles()" [(ngModel)]="usernameSearch"
          [placeholder]="'global.searchUserName' | translate">
      </div>
    </div>
    <!-- search -->
    <div *ngIf="areCustomerVehicles && currentUser.role.name === 'customer'"
      class="select bg-light my-2 col-md-4 col-lg-3" style="width: 380px; margin-right: 0;">
      <div class="p-0 search-text d-flex">
        <input type="text" class="form-control" (keydown.enter)="searchVehicles()" [(ngModel)]="useremailSearch"
          [placeholder]="'global.searchUserEmail' | translate">
      </div>
    </div>
    <div *ngIf="areCustomerVehicles && currentUser.role.name === 'customer'"
      class="select bg-light my-2 col-md-4 col-lg-3" style="width: 380px; margin-right: 0;">
      <div class="p-0 mb-2 search-text d-flex">
        <input type="text" class="form-control" (keydown.enter)="searchVehicles()" [(ngModel)]="clientNameSearch"
          [placeholder]="'global.searchClientName' | translate">
      </div>
    </div>
    <!-- ./search -->
  </div>

  <div class="row">
    <!-- search -->
    <div class="select bg-light my-2 col-md-4 col-lg-3" style="width: 380px; margin-right: 0;">
      <div class="d-flex" style="position: relative;">
        <input type="text" class="form-control" (keyup.enter)="addVin()" [(ngModel)]="vinSearch"
          [attr.placeholder]="'global.searchVin' | translate">
        <i class="fa fa-info-circle info" [ngbTooltip]="'You can search multiple VINs.'"></i>
      </div>
      <div class="d-flex" style="flex-wrap: wrap;">
        <div *ngFor="let vin of searchVins" class="d-flex badge badge-secondary m-1">
          <span class="mr-2">{{vin}}</span>
          <span style="cursor: pointer;" (click)="removeVin(vin)">x</span>
        </div>
      </div>
    </div>
    <div *ngIf="currentUser.role.name === 'root'" class="select bg-light my-2 col-md-4 col-lg-3">
      <input type="text" class="form-control" (keydown.enter)="searchVehicles()" [(ngModel)]="clientNameSearch"
        [placeholder]="'global.searchClientName' | translate">
    </div>
    <div class="select bg-light my-2 col-md-4 col-lg-3">
      <input type="text" class="form-control" (keydown.enter)="searchVehicles()" [(ngModel)]="licensePlateNumber"
        placeholder="Search by License Plate...">
    </div>

    <div *ngIf="areCustomerVehicles && currentUser.role.name === 'customer' && subcustomers.length"
      class="select bg-light my-2 col-md-4 col-lg-3 custom-select-list-wrapper" style="width: 380px;">
      <p class="select-item" (click)="showList = true" #toggleSelectList>{{selectItem}} <i class="fa fa-angle-down"></i>
      </p>
      <ul *ngIf="showList" #list class="custom-select-list">
        <li>
          <span (click)="searchSubcustomer(undefined, 'With all subcustomers', true)">With all
            subcustomers</span>
        </li>
        <li>
          <span (click)="searchSubcustomer(undefined, 'Without subcustomers', false)">Without
            subcustomers</span>
        </li>
        <ng-container *ngTemplateOutlet="Recursion; context:{ list: subcustomers}"></ng-container>
      </ul>
      <ng-template #Recursion let-list="list">
        <li *ngFor="let item of list">
          <span (click)="searchSubcustomer(item.id, item.name, false)">{{ item.name }}</span>
          <ul *ngIf="item.customers.length > 0" class="parent">
            <ng-container *ngTemplateOutlet="Recursion; context:{ list: item.customers }"></ng-container>
          </ul>
        </li>
      </ng-template>
    </div>

    <!-- filter -->
    <div *ngIf="areClientVehicles || areCustomerVehicles" class="select bg-light my-2 col-md-4 col-lg-3"
      style="width: 380px; margin-right: 0;">
      <div class="p-0 search-text d-flex">
        <select name="vehicleStatus" class="form-control" [(ngModel)]="vehicleStatus">
          <option value="">All Status</option>
          <option value="completed" translate>vehicles.finished</option>
          <option value="qc" translate>vehicles.qc</option>
          <option value="uploaded" translate>vehicles.uploaded</option>
          <option value="unuploaded" translate>vehicles.unuploaded</option>
          <option value="unprocessed" translate>vehicles.unprocessed</option>
        </select>
      </div>
    </div>
  </div>
  <div class="select mt-3">
    <div class="d-flex">
      <button class="btn btn-outline-secondary btn-search" (click)="searchVehicles(true)"
        translate>customer.search</button>
      <button *ngIf="areClientVehicles && currentUser.role.name === 'client'"
        class="btn btn-outline-secondary btn-search ml-3" (click)="countImages()">COUNT TOTAL IMAGES</button>
    </div>
    <p class="mr-3 mt-3" style="font-size: 1rem;" *ngIf="totalImages">Total images in all vehicles: {{totalImages}}</p>
  </div>
</div>

<app-modal (close)="toggleDateError = !toggleDateError" *ngIf="toggleDateError">
  <div class="modal_container black-text">
    <div class="modal-header">
      <h4 class="modal-title" translate>Error in Date Format</h4>
    </div>
    <div class="modal-body">
      <div style="font-size: 1rem;" class="mb-3">
        Date is not valid. Please write date in one of these formats.
      </div>
      <div style="font-size: 1.5rem; font-weight: bold; letter-spacing: 2px;" class="text-center">
        <p>YYYY-MM-DD</p>
        <p>YYYY/MM/DD</p>
        <p>YYYY.MM.DD</p>
      </div>
    </div>
  </div>
</app-modal>